import { Sms, User, Eye, EyeSlash } from "iconsax-react";
import { Link, useNavigate } from "react-router-dom";
import instance from "../../../axios/instance";
import { saveToken } from "../../../utils/token";
import { useEffect, useState } from "react";

export default function VitalRxLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);

  const btnDisabled = !email || !password;

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    try {
      const res = await instance.post("/doctor/auth/login", {
        email,
        password,
        type: "clinic"
      });
      saveToken(res.data.ACCESS_TOKEN);
      navigate("/dashboard/orders");
      // setSuccess(true);
      // setLoading(false);
    } catch (error) {
      setErrorMessage(error.response.data.message);
      setLoading(false);
    }
  };

  // // test effect
  // const [logo, setLogo] = useState(null)


  // useEffect(() => {
  //   const testLogo = window.localStorage.getItem("PHARM_LOGO")
  //   if (!testLogo) {
  //     console.log("There is no logo use default");
  //     setLogo("/images/Logo.png")
  //   } else {
  //     console.log("there is logo");
  //     setLogo("/images/Logo.png")
  //   }
  // }, [])

  return (
    <div className="min-h-screen flex">
      {/* Left Section - Login Form */}
      <div className="flex-1 bg-white flex flex-col justify-center px-8 lg:px-16 xl:px-24">
        <div className="max-w-md mx-auto w-full">
          {/* Logo */}
          <div className="mb-8">
            <img src="/clinic/images/vitalrx-logo.png" className="w-32 h-auto" alt="Pharmacy logo" />
          </div>

          {/* Main Content */}
          {success ? (
            <div className="text-gray-600 text-center">
              <div className="text-lg font-medium mb-2">Check your email</div>
              <div className="text-sm">A link has been sent to your email address. Click on it to sign in.</div>
            </div>
          ) : (
            <>
              <div className="mb-8">
                <p className="text-gray-600 text-sm">Welcome back! Please enter your details.</p>
              </div>


              {/* Login Form */}
              <form onSubmit={handleLogin} className="space-y-4">
                {/* Email Field */}
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Your Email
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Sms size={16} className="text-gray-400" />
                    </div>
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="block w-full pl-10 pr-3 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                </div>

                {/* Password Field */}
                <div>
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                    Your Password
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                    </div>
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="block w-full pl-10 pr-12 py-3 border border-gray-300 text-[14px] rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                      placeholder="Enter your password"
                      required
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <EyeSlash size={16} className="text-gray-400 hover:text-gray-600" />
                      ) : (
                        <Eye size={16} className="text-gray-400 hover:text-gray-600" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Error Message */}
                {errorMessage && (
                  <div className="text-red-500 text-sm font-medium">
                    {errorMessage}
                  </div>
                )}

                {/* Login Button */}
                <button
                  type="submit"
                  disabled={btnDisabled || loading}
                  className="w-full bg-[#007b7d] text-white py-3 px-4 rounded-lg font-medium hover:bg-gray-800 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? "Signing in..." : "Log in"}
                </button>
              </form>

              {/* Links */}
              <div className="mt-6 space-y-3 text-center">
                <Link
                  to="/auth/forgot-password"
                  className="text-sm text-gray-600 hover:text-gray-800 font-medium"
                >
                  Forgot password?
                </Link>


                {/* <div className="text-sm text-gray-600">
                  Don't have an account?{" "}
                  <Link
                    to="/auth/register"
                    className="font-medium text-gray-900 hover:text-gray-700"
                  >
                    Request an account
                  </Link>
                </div> */}
              </div>


              {/* Surescripts Badge */}
              {/* <div className="mt-8 text-center">
                <img src="/certified/surescripts-certified.webp" className="w-20 h-auto mx-auto" alt="Surescripts Certified" />
              </div> */}
            </>
          )}


        </div>
        <div className="font-regular w-full text-[12px] mt-4 text-center">
          {/* By signing in you agree to BlendcareRx's{" "}
                  <span className="text-primary">Terms of Uses</span>,{" "}
                  <span className="text-primary">Privacy Policy</span>,{" "}
                  <span className="text-primary">
                    HIPAA Policy, Delivery Policy
                  </span>
                  , and{" "}
                  <span className="text-primary">
                    HIPAA marketing authorization
                  </span> */}
          This website is the property of VitalRX Doctor. It is to be used only for approved access to services. By continuing this online access you are certifying that you have read and agree to abide by the regulations listed below. You will be held accountable for any activities not in compliance with those regulations. Misuse or unauthorized access may result in legal prosecution or penalties under law. Penalties may include fines, imprisonment, termination of affiliation with VitalRX Pharmacy. LOGOFF immediately if you do not agree to the conditions in this warning.
        </div>
      </div>

      {/* Right Section - Background Image */}
      <div style={{ backgroundImage: "url('/clinic/images/authimg2.jpg')" }} className="hidden lg:flex lg:flex-1 relative bg-center bg-cover bg-no-repeat">
        <div className="absolute inset-0 bg-gradient-to-br from-[#007b7d]/70 via-[#005a5c]/60 to-black/80">
          {/* Abstract shapes overlay */}
          <div className="absolute inset-0">
            <div className="absolute top-20 left-10 w-32 h-32 bg-[#007b7d]/20 rounded-full blur-xl"></div>
            <div className="absolute top-40 right-20 w-24 h-24 bg-[#007b7d]/15 rounded-full blur-xl"></div>
            <div className="absolute bottom-40 left-20 w-40 h-40 bg-[#005a5c]/25 rounded-full blur-xl"></div>
            <div className="absolute bottom-20 right-10 w-28 h-28 bg-[#007b7d]/10 rounded-full blur-xl"></div>
          </div>

          {/* Mountain silhouette */}
          <div className="absolute bottom-0 right-0 w-full h-32">
            <svg viewBox="0 0 400 100" className="w-full h-full">
              <path d="M0,100 L50,60 L100,80 L150,40 L200,70 L250,30 L300,50 L350,20 L400,40 L400,100 Z"
                fill="rgba(0,123,125,0.4)" />
            </svg>
          </div>


        </div>
      </div>
      {/* Powered by */}
      <div className="absolute bottom-4 left-4 flex items-center gap-2 text-[#111111] text-xs">
        <span>Powered by</span>
        <img src="/clinic/images/logo-bw.png" className="w-24 h-auto" alt="BCRX" />
      </div>
    </div>
  );
}
